import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router';
import { Container, Col, TextInput, Collection, CollectionItem } from 'react-materialize';
import $ from 'jquery';
import styled from 'styled-components';
import Row from '../organism/row.jsx';
import Path from '../molecules/path.jsx';
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Share from "yet-another-react-lightbox/plugins/share";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import PhotoAlbum from "react-photo-album";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import { Label } from '../atoms/label.jsx';
import { COLOR, FONT_FAMILY, URL, SCREEN_MEDIA, LABEL, SIZE } from '../../utils/constants.js';
import { useDecorationTypes } from '../hooks/useDecorationTypes.js';
import { useDecorations } from '../hooks/useDecorations.js';
import {
    getDecorationTypeLv1List,
    getDecorationTypesFromSearchPhrase,
    getDecorationLowList
} from '../../utils/managersearch.js';
import Button from '../atoms/button.jsx';
import TextIcon from '../atoms/texticon.jsx';
import TextButton from '../atoms/textbutton.jsx';
import LoadingSpinner from '../organism/spinner.jsx';


import PathIcSarch from '../../icons/ic_search.svg'
import PathIcStarFilled from '../../icons/ic_star_filled.svg'
import PathIconTikTokCircle from '../../icons/ic_tiktok_inv_circled.svg'


const TextInputLayer = styled.div`
    height: 45px;
    width: 100%;
    border: 2px solid ${COLOR.ferra};
    border-radius: 4px;
    cursor: text;
`;

const SearchSuggestionBackground = styled.div`
    height: 100%; // It is not working, this is set dynamically
    width: 100%;
    position: absolute;
    background-color: ${COLOR.background};
    display: none;
    @media only screen and ${SCREEN_MEDIA.small} {
        top: 0px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        top: 0px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        top: 0px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        top: 0px;
    }
    z-index: 1;
`;

const SearcherSuggestionDiv = styled.div`
    height: 400px;
    background-color: ${COLOR.white};
    overflow: auto;
    position: absolute;
    @media only screen and ${SCREEN_MEDIA.small} {
        width:90%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        width:85%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        width:70%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        width:70%;
        top: 90px;
    }
`


const BodyDecorations = () => {

    const { searchId } = useParams();
    const [page, setPage] = useState(0);

    console.log(`DECORATIONS searchId: ${searchId}`)

    const fetchedDecorationTypeList = useDecorationTypes();
    const { data: fetchedDecorationList, hasMoreData } = useDecorations(searchId, page);

    const navigate = useNavigate();

    const [index, setIndex] = useState(-1);

    const [descriptionMaxLines, setDescriptionMaxLines] = useState(3);
    const [descriptionTextAlign, setDescriptionTextAlign] = useState("end"); //"start" | "end" | "center"
    
    const searchInputTextRef = useRef()
    const loaderRef = useRef(null)

    const [decorationTypeList, setDecorationTypeList] = useState([]);
    const [decorationList, setDecorationList] = useState([]);
    const [decorationLowList, setDecorationLowList] = useState([]);
    
    const [searchSuggestionList, setSearchSuggestionList] = useState([])
    const [isNextPageLoading, setIsNextPageLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(true)


    useEffect(() => {
        if (fetchedDecorationTypeList && fetchedDecorationTypeList.length > 0) {
            setDecorationTypeList(fetchedDecorationTypeList)
            setSearchSuggestionList(getDecorationTypeLv1List(fetchedDecorationTypeList))
        }
    }, [fetchedDecorationTypeList]) // Separating setDecorationTypeList to not invoke everytime new page list arrives.

    useEffect(() => {
        if (fetchedDecorationList && fetchedDecorationList.length > 0 && fetchedDecorationTypeList && fetchedDecorationTypeList.length > 0) {
            const appendDecorationList = [...decorationList, ...fetchedDecorationList]
            const fetchedDecorationLowList = getDecorationLowList(fetchedDecorationList)
            const appendDecorationLowList = [...decorationLowList, ...fetchedDecorationLowList]
            setDecorationList(appendDecorationList)
            console.log("item:", appendDecorationLowList[0])
            setDecorationLowList(appendDecorationLowList)
            setIsNextPageLoading(false)
            setIsLoading(false)
        }
    }, [fetchedDecorationList, fetchedDecorationTypeList]) // Making sure isLoading false when both lists arrives.


    // VERY IMPORTANT. USE EFFECT ALWAYS IS EXECUTED AFTER RENDER.
    useEffect(() => {
        if (isLoading || isNextPageLoading || !hasMoreData) return; // After first loading, isLoading is always false.
        const observer = new IntersectionObserver((entries) => {
            const target = entries[0];
            if (target.isIntersecting && hasMoreData) {
                setIsNextPageLoading(true);
                setPage((prev) => prev + 1); // Trigger next page
            }
        }, { threshold: 1.0 });

        if (loaderRef.current) observer.observe(loaderRef.current);

        return () => observer.disconnect();
    }, [isLoading, isNextPageLoading, hasMoreData]);

    // VERY IMPORTANT. USE EFFECT ALWAYS IS EXECUTED AFTER RENDER.
    useEffect(() => {
        if (!isLoading) {
            window.scrollTo(0, 0);
        }
      }, [isLoading]);


    const navigateToDecorations = (searchId) => {
        const path = URL.decorations.replace(':searchId', searchId);
        navigate(path)
    }

    const handleSearchOnkeyDown = (event) => {
        if (event.key === 'Enter') {
        }
    }

    const handleOnSearchDismissed = () => {
        $(searchInputTextRef.current).blur()
        $('#search_suggestion_background').css('display', 'none')
    }
    
    const onSearchInputLayerClicked = () => {
        $('#search_suggestion_background').css('height', $('#root').height());
        $('#search_suggestion_background').css('display', 'block')
        $(searchInputTextRef.current).focus()
    }

    const onSearchInputTextChanges = (event) => {
        const searchPhrase = event.target.value.trim()
        const suggestionList = getDecorationTypesFromSearchPhrase(decorationTypeList, searchPhrase)
        setSearchSuggestionList(suggestionList)
    }

    if (isLoading) return <LoadingSpinner/>;

    return(
        <div>
            <Container>
                <Row className='valign-wrapper' margin='40px 0'>
                    <TextInputLayer
                        onClick={ () => { onSearchInputLayerClicked() } }>
                        <Label
                        text_color={COLOR.gray}
                        text_size='20px'
                        font_family={FONT_FAMILY.avenirBook}
                        margin='7px 14px'>
                        Buscar temática
                        </Label>
                    </TextInputLayer>
                </Row>

                <Row
                    margin='0 0'>
                    <Path 
                        endpoint={`${LABEL.thematics}/${LABEL.decorations}`} />
                </Row>

                <Row margin='20px 0'>
                    <PhotoAlbum
                        layout="rows"
                        photos={ decorationLowList }
                        targetRowHeight={300}
                        onClick={({ index: current }) => setIndex(current)}
                        renderPhoto={({ photo, wrapperStyle, imageProps }) => (
                            <div style={{ 
                                ...wrapperStyle, 
                                position: "relative",
                                overflow: "hidden" 
                            }}>
                                <img 
                                    {...imageProps} 
                                    style={{ 
                                        ...imageProps.style, 
                                        width: "100%", 
                                        height: "100%", 
                                        objectFit: "cover", // Replace with objectPosition: "center" to make image cover the layout without getting cropped.
                                    }} 
                                />
                                <div
                                style={{
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                display: "flex",
                                justifyContent: "flex-end"
                                }}
                                >
                                { process.env.NODE_ENV === 'development' && (
                                    <div style={{ background: "rgba(0,0,0,0.5)" }}>
                                    <TextIcon
                                    ic_path={ PathIcStarFilled }
                                    ic_size='15px'
                                    font_family={FONT_FAMILY.avenirMedium}
                                    text_color={COLOR.white}
                                    text_size='12px'
                                    separation='2px'
                                    margin='5px 5px'>
                                    {photo.aestheticScore}
                                    </TextIcon>
                                    </div>
                                    )
                                }
                                { photo.videoUrl && (
                                    <div>
                                    <TextButton
                                    key={`tiktok_key_${photo.id}`}
                                    href={photo.videoUrl}
                                    target="_blank"
                                    ic_path={PathIconTikTokCircle}
                                    ic_size='30px'
                                    margin='5px 5px'
                                    separation='0px'
                                    />
                                    </div>
                                    )
                                }
                                </div>
                            </div>
                        )}
                    />

                    <Lightbox
                        index={index}
                        plugins={ [Counter, Share, Captions, Zoom] }
                        captions={ { descriptionTextAlign, descriptionMaxLines } }
                        counter={ { container: { style: { top: "unset", bottom: 0 } } } }
                        slides={ decorationList }
                        open={ index >= 0 }
                        close={ () => setIndex(-1) }
                    />
                </Row>
                <Row>
                    {/* The Sentinel: When this is visible, we load more */}
                    <div ref={loaderRef} style={{ height: '20px', background: 'transparent' }}>
                        {/* <p>Loading more...</p> */}
                    </div>
                </Row>
            </Container>

            <SearchSuggestionBackground
                id='search_suggestion_background'
                onClick={ () => { handleOnSearchDismissed() } }>
                <Container>
                <Row margin='40px 0'>
                    <Col s={8} m={8} l={10} xl={11}>
                        <TextInput
                        ref={searchInputTextRef}
                        placeholder='Buscar temática'
                        onChange={ (event) => { onSearchInputTextChanges(event) } }
                        onKeyDown={ (event) => { handleSearchOnkeyDown(event) } }/>
                    </Col>
                    <Col s={4} m={4} l={2} xl={1}>
                    <Button
                        onClick={ () => { handleOnSearchDismissed() } }
                        height='40px'>
                        <Label
                        font_family={FONT_FAMILY.avenirLight}
                        text_color={COLOR.ferra}>
                            { LABEL.cancel }
                        </Label>
                    </Button>
                    
                    </Col>
                </Row>
                <Row>
                    <SearcherSuggestionDiv>
                    <Collection>
                    {
                        searchSuggestionList.map((searchSuggestion, index) =>
                            <CollectionItem
                                key={index}
                                onClick={ () => { navigateToDecorations(searchSuggestion.id) } }
                                style={{ cursor: 'pointer' }}>
                                <TextIcon
                                    ic_path={PathIcSarch}
                                    ic_size='18px'
                                    ic_color={COLOR.ferra}>
                                </TextIcon>
                                <Label
                                    text_size={SIZE.subtitle}
                                    text_color={COLOR.ferra}
                                    font_family={FONT_FAMILY.avenirMedium}> 
                                    {searchSuggestion.title}
                                </Label>
                                
                            </CollectionItem>
                        )
                    }
                    </Collection>
                    </SearcherSuggestionDiv>
                </Row>
                </Container>
            </SearchSuggestionBackground>
        </div>
    )
}

export default BodyDecorations;